import { GraphQlClient } from '@intelipost-js/secure-providers';
import { ScToast } from '@intelipost-js/secure-components';

export default {
  getTransactionReverses({ commit }, { filters = {}, pagination = {} }) {
    commit('toggleLoading', true);
    const { created_date, shipment_table_states, ...fmtFilters } = filters || {};
    let shipment_table_states_fmt = [];

    if (shipment_table_states.length > 0) {
      shipment_table_states_fmt = [...shipment_table_states.map(item => item.value)];
    }

    return GraphQlClient.query(`
      query(
        $shipment_order_sub_type: Int
        $shipment_table_states: [String]
        $logistic_provider_id: Int
        $date_range: DateRangeInput
        $order_numbers: [String]
        $page: Int
        $limit: Int
      ) {
        reverse(
          shipment_order_sub_type: $shipment_order_sub_type
          shipment_table_states: $shipment_table_states
          logistic_provider_id: $logistic_provider_id
          date_range: $date_range
          order_numbers: $order_numbers
          page: $page
          limit: $limit
        ) {
          order {
            order_number
            parent_order_number
            shipment_order_sub_type
            authorization_code
            created
            estimated_collect
            shipment_order_volume_state_localized
            eticket_status_localized
            eticket_error
            volumes {
              tracking_code
              invoice {
                number
              }
              volume_number
            }
            end_customer {
              first_name
              last_name
              full_name
              name
              document
              incorret_zipcode
            }
          }
          total
        }
      }`, Object.assign(
        fmtFilters,
        { date_range: created_date },
        { shipment_table_states: shipment_table_states_fmt },
        pagination,
      )).then(({ data = {} }) => {
        const {
          reverse = {},
        } = data;
        const {
          order = [],
          total = 0,
        } = reverse;

        commit('toggleLoading', false);
        commit('setTransactionReverses', order);
        commit('setTransactionReversesTotal', total);
        return Promise.resolve(data);
      }).catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },

  exportTransactionsReverse({ commit }, { filters = {} }) {
    commit('toggleLoadingExporting', true);
    const {
      created_date = {},
      shipment_table_states = [],
      shipment_order_sub_type = 0,
      logistic_provider_id = 0,
    } = filters || {};

    const shipment_table_states_fmt = [
      ...shipment_table_states.map(item => item.value),
    ];
    const params = Object.assign({},
      {
        logistic_provider_id,
        shipment_order_sub_type,
        date_range: created_date,
        shipment_table_states: shipment_table_states_fmt,
      },
    );

    return GraphQlClient.mutation(`
      mutation (
        $shipment_order_sub_type: Int
        $shipment_table_states: [Int]
        $logistic_provider_id: Int
        $date_range: DateRangeInput
      ) {
        reverseExport (
          shipment_order_sub_type: $shipment_order_sub_type
          shipment_table_states: $shipment_table_states
          logistic_provider_id: $logistic_provider_id
          date_range: $date_range
        ) {
          ok
        }
      }`, params)
      .then((res) => {
        commit('toggleLoadingExporting', false);
        ScToast.success('O arquivo de relatório está sendo gerado, em instantes estará disponível na seção "Meus Arquivos".');
        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('toggleLoadingExporting', false);
        return Promise.reject(err);
      });
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-reverse/features/transactions-reverse/store/actions.js